import React, { Fragment, useEffect } from "react";
import "./WhyJoinUs.css";
import "./WorkAtJioInstitute.css";
import "slick-carousel";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import $ from "jquery";

function WorkAtJioInstitute() {
  var settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
  };
  //
  $.fn.dataImg = function (options) {
    var settings = $.extend(
      {
        sml: 400,

        med: 800,

        lrg: 1000,

        resize: false,
      },
      options,
    );

    var elements = $(this);

    function getSrc(element) {
      var screen = $(window).width();

      if (screen > settings.med) {
        return element.data("lrg");
      } else if (screen <= settings.med && screen > settings.sml) {
        return element.data("med");
      }

      return element.data("sml");
    }

    function breakpoints() {
      elements.each(function () {
        var e = $(this);

        var src = getSrc(e);

        if (src != undefined) {
          if (e.is("img")) {
            e.attr("src", src);
          } else {
            e.css("background-image", "url(" + src + ")");
          }
        }
      });
    }
    breakpoints();

    if (settings.resize === true) {
      $(window).resize(function () {
        breakpoints();
      });
    }
  };

  let isMobile = window.innerWidth < 768;

  //
  // $(document).ready(function () {
  // 	$(".header-mobile-menu").click(function () {
  // 		$(".nav-wrapper").toggleClass("show-menu");
  // 	});
  // });
  $(document).ready(function () {
    $(".section-slider").slick({
      dots: false,
      arrows: true,
      speed: 400,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  });

  return (
    <>
      <div className="main-container full_width why-join-us work-at-jio-institute">
        <section className="section-masthead space-before-breadcrumb section-common-space masthead-mob-space overflow-hidden sectionnocolorbg  wju-section-1  my-0 py-0 section-container">
          <div className="container d-none">
            <div className="row d-flex">
              <div className="col-lg-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Work At Jio Institute
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
          <div className="full_width_banner">
            <img
              src="/assets/images/career/work-at-jio-institute-banner.png"
              class="d-block w-100"
              alt="..."
            />
            <div class="carousel-caption banner-caption container w-100">
              <h5>Work at Jio Institute</h5>
              <p>
                Be a part of building a vibrant ecosystem for research,
                innovation and entrepreneurship.
              </p>
            </div>
          </div>
        </section>
        <section id="navbar-example3" className="section-common-space overflow-hidden sectionnocolorbg section-container section-nav-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <nav id="navbar-example2" class="section-nav navbar-light">
                  <ul class="nav nav-pills">
                    <li class="nav-item">
                      <a class="nav-link" href="#build-a-career">Build A Career with Jio Institute</a>
                    </li>
                    <li class="nav-item mx-3 mx-md-4">
                      <a class="nav-link" href="#current-openings">Current Openings</a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="#why-jio-institute">Why Jio Institute</a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </section>
        <div data-bs-spy="scroll" data-bs-target="#navbar-example3" data-bs-offset="0" tabindex="0">
          <section className="my-5 shape-future-section" id="build-a-career">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 d-flex align-items-center flex-column justify-content-center">
                  <h2 class="h2-01 font-black">
                    Shape the Future of Higher Education with Jio Institute
                  </h2>
                  <div class="font-medium body-01 mt-2 mb-3">
                    At Jio Institute, we are building a globally benchmarked,
                    research-driven institute rooted in innovation,
                    interdisciplinary learning, and real-world impact. We invite
                    educators, researchers, and professionals to be part of an
                    institution that is redefining higher education in India and
                    beyond. This is a rare opportunity to contribute to an
                    institution from the ground up—working alongside exceptional
                    minds to create something enduring.
                  </div>
                </div>
                <div className="col-lg-6">
                  <div
                    class="img-wrapper img-caption-overlay"
                    data-bs-interval="10000"
                  >
                    <img
                      src="/assets/images/career/Teach Discover Build.JPG"
                      class=""
                      alt="..."
                    />
                    <div class="carousel-caption">
                      <h5 className="h2-02">Teach. Discover. Build.</h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Video section */}
          <section className="section-common-space overflow-hidden video-section">
            <div className="container">
              <div className="row">
                <div className="col-12 text-center">
                  <iframe
                    className="iframe-temp-wrapper "
                    src={process.env.REACT_APP_INTRO_VIDEO_LINK}
                    title="YouTube video player"
                    frameBorder="0"
                    marginHeight="0"
                    marginWidth="0"
                    scrolling="no"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    style={
                      isMobile
                        ? { borderRadius: "15px" }
                        : { borderRadius: "15px" }
                    }
                  ></iframe>
                </div>
              </div>
            </div>
          </section>
          {/* Video section  end s */}
          <section className="openings-section" id="current-openings">
            <div class="container my-5">
              <h2 class="fw-bold mb-4">Current Job Openings</h2>

              <div class="row g-4">
                <div class="col-md-6 mb-3">
                  <a
                    href="/current-openings/Academics"
                    class="text-decoration-none d-block"
                  >
                    <div class="job-card">
                      <div class=" img-caption-overlay">
                        <img
                          src="/assets/images/career/Academic openings.JPG"
                          class="img-fluid w-100"
                          alt="Academic"
                        />
                        <div class="carousel-caption">
                          <div class="d-flex justify-content-between align-items-center">
                            <h3 class="text-white fs-4 fw-semibold">
                              Academic Openings
                            </h3>
                            <div class="arrow-icon text-white">→</div>
                          </div>
                        </div>
                      </div>
                      <div class="bg-white pt-4">
                        <p class="text-muted mb-0">
                          Explore current openings for academic & research roles at
                          Jio Institute. Check out available positions now !
                        </p>
                      </div>
                    </div>
                  </a>
                </div>

                <div class="col-md-6">
                  <a
                    href="/current-openings/Non-Academic"
                    class="text-decoration-none d-block"
                  >
                    <div class="job-card">
                      <div class=" img-caption-overlay">
                        <img
                          src="/assets/images/career/Non-academic- why at JI.JPG"
                          class="img-fluid w-100"
                          alt="Non-Academic"
                        />
                        <div class="carousel-caption">
                          <div class="d-flex justify-content-between align-items-center">
                            <h3 class="text-white fs-4 fw-semibold">
                              Non-Academic Openings
                            </h3>
                            <div class="arrow-icon text-white">→</div>
                          </div>
                        </div>
                      </div>
                      <div class="bg-white pt-4">
                        <p class="text-muted mb-0">
                          Explore current openings for administrative & non-academic
                          roles at Jio Institute. Check out available positions now
                          !
                        </p>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </section>
          <section class="contact-section bg-primary">
            <div class="container">
              <div class="row align-items-center">
                <div class="col-lg-6 my-2 my-md-5 text-white">
                  <h1 class="display-5 fw-bold mb-4">JOIN OUR TALENT NETWORK</h1>
                  <p class="lead opacity-90">
                    Stay connected with Jio Institute and be the first to know
                    about new opportunities, events, and updates. By joining our
                    talent network, you can explore future possibilities and
                    remain engaged with our growing community.  We welcome
                    speculative applications and encourage you to send your
                    profile for future opportunities.
                  </p>
                </div>

                <div class="col-lg-5 offset-lg-1">
                  <div class="contact-card rounded-0">
                    <h2 class="fw-bold mb-4">Contact Us</h2>

                    <div className="d-flex flex-column flex-lg-row">
                      <div class="d-none mb-4 align-items-center">
                        <i class="bi bi-telephone icon-blue me-3"></i>
                        <div>
                          <a href="tel:04023187777" class="contact-link d-block">
                            040 23187777
                          </a>
                          <a href="tel:01724591800" class="contact-link d-block">
                            0172 4591800
                          </a>
                        </div>
                      </div>

                      <div class="d-flex mb-4 flex-column flex-md-row flex-lg-column">
                        <i class="bi bi-envelope icon-blue me-3"></i>
                        <div>
                          <ul class="list-unstyled mb-0 flex-column flex-sm-row flex-md-column">
                            <li class="mb-3">
                              <span>For Non-Academic & General Queries</span>
                              <a
                                href="mailto:careers@jioinstitute.edu.in"
                                class="contact-link d-block fs-4"
                              >
                                careers@jioinstitute.edu.in
                              </a>
                            </li>
                            <li class="mb-3">
                              <span>For Academic Openings</span>
                              <a
                                href="mailto:facultyhiring@jioinstitute.edu.in"
                                class="contact-link d-block fs-4"
                              >
                                facultyhiring@jioinstitute.edu.in
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="my-5 why-jio-institute-section" id="why-jio-institute">
            <div className="container">
              <div className="row">
                <div className="col-lg-12">
                  <h2 class="h2-01 font-black">Why Jio Institute?</h2>
                  <div class="font-medium body-01 mt-2 mb-3">
                    <p>
                      Jio Institute is envisioned as a next-generation institution
                      committed to excellence in teaching, research, and societal
                      impact. Established with the aspiration to be among the
                      world’s leading institutions, Jio Institute brings together
                      the strengths of academic rigor, industry integration, and
                      technological advancement.
                    </p>
                    <p>
                      As part of this journey, we are building a community of
                      exceptional individuals who are driven by purpose, inspired
                      by innovation, and committed to creating meaningful impact.
                    </p>
                    <p>
                      Working at Jio Institute is not just about taking up a
                      role—it is about contributing to the creation of a
                      forward-looking institution that nurtures talent, fosters
                      discovery, and addresses real-world challenges.
                    </p>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div
                    class="img-wrapper img-caption-overlay"
                    data-bs-interval="10000"
                  >
                    <img
                      src="/assets/images/career/Why Join Jio Institute 1.JPG"
                      class=""
                      alt="..."
                    />
                  </div>
                </div>
                <div className="col-lg-6 d-flex align-items-center flex-column justify-content-center">
                  <div class="inner-nav-wrapper d-flex flex-column align-items-start">
                    <a href="/benefits" class="why-jio-institute-links">
                      <span>Benefits</span>
                      <div class="arrow-icon">〉</div>
                    </a>
                    <hr />
                    <a href="/our-values" class="why-jio-institute-links">
                      <span>Our Values</span>
                      <div class="arrow-icon">〉</div>
                    </a>
                    <hr />
                    <a
                      href="/career-growth-pathways"
                      class="why-jio-institute-links"
                    >
                      <span>Career & Growth Pathways</span>
                      <div class="arrow-icon">〉</div>
                    </a>
                    <hr />
                    <a href="/what-drives-us" class="why-jio-institute-links">
                      <span>What Drives Us</span>
                      <div class="arrow-icon">〉</div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default WorkAtJioInstitute;
